import React from 'react'
import { BasicInfoWrapperProps } from '../BasicInfo'
import PriceMaximizer from '../../../../../common/display/priceMaximizer/PriceMaximizer'
import { RecommendedPriceNotification } from '../recommended-price-notification/RecommendedPriceNotification'

export const priceMaximizer = () => (props: BasicInfoWrapperProps) => (
  <PriceMaximizer insertionData={props.insertionData} />
)

export const recommendedPriceNotification = () => (_props: BasicInfoWrapperProps) => <RecommendedPriceNotification />
